import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { ZoneService } from '../proxy/planning/controllers/zone.service';

FieldBuilder.setNamespace('Planning');

export const FIREBREAKBLOCK_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('gisLandBlockId', 'Entity.Firebreak.GISFirebreakId')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .required()
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const FIREBREAKBLOCK_CONFIG = {
  entityName: 'FirebreakBlock',
  localizationKey: 'Planning::Entity.FirebreakBlock',
  permission: 'PlanningLocation.FirebreakBlocks',
  fields: FIREBREAKBLOCK_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
